import React, { Component } from 'react';

//componentes
import SegundoTrimestre from './segundoTrimestre'

class Index extends Component {

    render(){
        return(
            <div>
                <SegundoTrimestre />
            </div>
        );
    }

}
export default Index;